import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OpenBook from "../icons/openbook.jsx";
import ArrowR from "../icons/arrowR.jsx";
import { getCoursesProgress } from "../service/courses.servide.js";
import { getLocalUser } from "../utils/authUtils.js";

export default function Selector(props) {
  const [exerciceState, setExerciceState] = useState("");

  const getUserCourseData = async () => {
    const user = getLocalUser();
    const userId = user?.userId;

    if (!userId) {
      return;
    }

    try {
      const { data } = await getCoursesProgress(userId);
      const currentExercice = data?.exercisesInfo?.find(
        (elemento) => elemento.id === props.path
      );

      if (currentExercice) {
        currentExercice.successes >= 1
          ? setExerciceState("green")
          : setExerciceState("red");
      }
    } catch (error) {
      if (process.env.NODE_ENV === "development") {
        console.warn("No se pudo cargar el progreso del ejercicio", error);
      }
    }
  };

  useEffect(() => {
    getUserCourseData();
  }, [props.path]);

  if (props.idPdf) {
    return (
      <a
        href={props.path}
        target="_blank"
        rel="noopener noreferrer"
        className={`m-selector ${exerciceState}`}
        data-ex={props.path}
        id={props.id}
      >
        <div className="m-select-text">
          <OpenBook />
          <div>{props.title}</div>
        </div>
        <ArrowR />
      </a>
    );
  }

  return (
    <Link className={`m-selector ${exerciceState}`} data-ex={props.path} id={props.id} to={props.path}>
      <div className="m-select-text">
        <OpenBook />
        <div>{props.title}</div>
      </div>
      <ArrowR />
    </Link>
  );
}
